export default function apiTabFromReduxTab(tab) {
	return {
		binder_id: tab.binderId,
		client_id: tab.clientId,
		content: tab.content,
		edit_criterion_name: tab.editCriterionName,
		edit_joinpath_name: tab.editJoinpathName,
		editable: tab.editable,
		id: tab.id,
		link_id: tab.linkId,
		patent_cloud: tab.patentCloud,
		iFrame: tab.iFrame,
		search: tab.search,
		tableau: tab.tableau,
		title: tab.title,
	};
}
